export const statusOptions = [
    { id: 1, label: 'active', color: '#409c28'},
    { id: 2, label: 'suspended', color: '#d89d2b'},
    { id: 3, label: 'terminated', color: '#c13d3d'},
];

export const getStatusById = (id) => {
    return statusOptions.find(status => status.id === id);
};
  
export const positionOptions = [
    { id: 1, label: 'ceo' },
    { id: 2, label: 'manager' },
    { id: 3, label: 'quality_control' },
    { id: 4, label: 'sales' },
    { id: 5, label: 'production' },
    { id: 6, label: 'marketing' },
    { id: 7, label: 'logistics' },
];

export const getPositionById = (id) => {
    return positionOptions.find(position => position.id === id);
};

export const bankOptions = [
    { id: 1, label: 'BROU' },
    { id: 2, label: 'BBVA' },
    { id: 3, label: 'ITAU' },
    { id: 4, label: 'SANTANDER' },
    { id: 5, label: 'SCOTIABANK' },
    { id: 10, label: 'No aplica' },
];

export const getBankById = (id) => {
    return bankOptions.find(bank => bank.id === id);
};

export const unitOptions = [
    { id: 1, label: 'Gramos' },
    { id: 2, label: 'KG' },
    { id: 3, label: 'Litros' },
    { id: 4, label: 'ML' },
    { id: 5, label: 'Unidades' },
    { id: 6, label: 'Bochas' },
];

export const getUnitById = (id) => {
    return unitOptions.find(unit => unit.id === id) || { label: 'Unknown', id: 'Unknown' };
};

export const daysOfWeekOptions = [
    { id: 'L', label: 'monday' },
    { id: 'M', label: 'tuesday' },
    { id: 'X', label: 'wednesday' },
    { id: 'J', label: 'thursday' },
    { id: 'V', label: 'friday' },
    { id: 'S', label: 'saturday' },
    { id: 'D', label: 'sunday' },
];

export const getDayOfWeekById = (id) => {
    return daysOfWeekOptions.find(day => day.id === id);
};

export const permissionOptions = [
    // Super Admin [1-99]
    { id: 1, label: 'SUPER_ADMIN' },
    { id: 2, label: 'MANAGE_TENANTS' },
    
    // Reports codes [100 - 199]
    { id: 100, label: 'VIEW_SALES_REPORTS' },
    { id: 101, label: 'VIEW_INVENTORY_REPORTS' },
    { id: 102, label: 'VIEW_DISCOUNTS_REPORTS' },
    { id: 103, label: 'VIEW_COST_REPORTS' },
    { id: 104, label: 'VIEW_CLIENTS_REPORTS' },
    { id: 105, label: 'VIEW_BRANCH_REPORTS' },
    
    // Stock codes [200 - 299]
    { id: 200, label: 'VIEW_MOVEMENTS_STOCK' },
    { id: 201, label: 'CREATE_MOVEMENTS_STOCK' },
    { id: 202, label: 'MANAGE_STOCK_COUNT_CONFIG' },
    { id: 203, label: 'EXECUTE_STOCK_COUNT' },
    { id: 204, label: 'VIEW_STOCK_COUNT_RESULTS' },
    { id: 205, label: 'APPROVE_STOCK_COUNT_ADJUSTMENT' },
    { id: 206, label: 'VIEW_STOCK_HISTORY' },

    // Client codes [300 - 399]
    { id: 300, label: 'VIEW_CLIENTS' },
    { id: 311, label: 'CREATE_CLIENTS' },
    { id: 312, label: 'DELETE_CLIENTS' },
    { id: 313, label: 'UPDATE_CLIENTS' },
    
    // Manage locations codes [400 - 499]
    { id: 400, label: 'VIEW_MANAGE_LOCATIONS' },
    { id: 401, label: 'VIEW_MANAGE_STAFF' },
    { id: 411, label: 'CREATE_LOCATION' },
    { id: 412, label: 'UPDATE_LOCATION' },
    { id: 413, label: 'DELETE_LOCATION' },
    { id: 421, label: 'CREATE_STAFF' },
    { id: 422, label: 'DELETE_STAFF' },
    { id: 423, label: 'UPDATE_STAFF' },
    { id: 424, label: 'MANAGE_STAFF_ROLES' },
    { id: 425, label: 'MANAGE_TERMINALS' },
    { id: 426, label: 'VIEW_OPEN_CLOSE_CASH' },
    { id: 427, label: 'GET_ALL_OPEN_CLOSE_CASH_REGISTER' },
    { id: 428, label: 'VIEW_BUSINESS_UNITS' },
    { id: 429, label: 'CREATE_BUSINESS_UNITS' },
    { id: 430, label: 'UPDATE_BUSINESS_UNITS' },
    { id: 431, label: 'DELETE_BUSINESS_UNITS' },
    
    // Location codes [500 - 599]
    { id: 500, label: 'VIEW_LOCATION' },
    { id: 501, label: 'VIEW_SALES' },
    { id: 502, label: 'VIEW_INVENTORY' },
    { id: 503, label: 'VIEW_STAFF' },
    { id: 504, label: 'VIEW_TASKS' },
    { id: 510, label: 'UPDATE_INVENTORY' },
    { id: 511, label: 'MANAGE_TASKS' },
    { id: 521, label: 'VIEW_SCHEDULE' },
    { id: 522, label: 'UPDATE_SCHEDULE' },
    { id: 530, label: 'OPEN_CASH_REGISTER' },
    { id: 531, label: 'CLOSE_CASH_REGISTER' },
    
    // Products codes [600 - 699]
    { id: 600, label: 'VIEW_PRODUCTS' },
    { id: 601, label: 'VIEW_BATCHES' },
    { id: 602, label: 'VIEW_SUPPLIES' },
    { id: 603, label: 'VIEW_PREPARATIONS' },
    { id: 611, label: 'CREATE_PRODUCTS' },
    { id: 612, label: 'UPDATE_PRODUCTS' },
    { id: 613, label: 'DELETE_PRODUCTS' },
    { id: 614, label: 'VIEW_COST_PRODUCTS' },
    { id: 621, label: 'CREATE_BATCHES' },
    { id: 622, label: 'UPDATE_BATCHES' },
    { id: 623, label: 'DELETE_BATCHES' },
    { id: 631, label: 'CREATE_SUPPLIES' },
    { id: 632, label: 'UPDATE_SUPPLIES' },
    { id: 633, label: 'DELETE_SUPPLIES' },
    { id: 634, label: 'REPLENISHMENT_SUPPLIES' },
    { id: 635, label: 'REPLENISHMENT_RETAIL_PRODUCTS' },
    { id: 641, label: 'CREATE_PREPARATIONS' },
    { id: 642, label: 'UPDATE_PREPARATIONS' },
    { id: 643, label: 'DELETE_PREPARATIONS' },
    
    // Suppliers codes [700 - 749]
    { id: 700, label: 'VIEW_SUPPLIERS' },
    { id: 711, label: 'CREATE_SUPPLIERS' },
    { id: 712, label: 'UPDATE_SUPPLIERS' },
    { id: 713, label: 'DELETE_SUPPLIERS' },
    
    // Categories codes [750 - 799]
    { id: 750, label: 'VIEW_CATEGORY' },
    { id: 751, label: 'CREATE_CATEGORY' },
    { id: 752, label: 'UPDATE_CATEGORY' },
    { id: 753, label: 'DELETE_CATEGORY' },
    { id: 754, label: 'MANAGE_CATEGORY_VIEW_PRODUCTS' },

    // Settings codes [800 - 899]
    { id: 801, label: 'VIEW_ROLES_PERMISSIONS' },
    { id: 802, label: 'VIEW_SETTINGS' },
    { id: 810, label: 'CREATE_ROLES' },
    { id: 811, label: 'UPDATE_ROLES' },
    { id: 812, label: 'DELETE_ROLES' },
    { id: 821, label: 'UPDATE_SETTINGS' },
    { id: 822, label: 'VIEW_OBJECTIVES' },
    { id: 823, label: 'MANAGE_OBJECTIVES' },
    { id: 825, label: 'MANAGE_COMPANY_IDENTITY' },
    { id: 826, label: 'MANAGE_PLUGINS' },
    
    // Plant codes [900 - 999]
    { id: 900, label: 'VIEW_RESOURCES' },
    { id: 901, label: 'VIEW_PRODUCTION' },
    { id: 910, label: 'CREATE_RESOURCES' },
    { id: 911, label: 'UPDATE_RESOURCES' },
    { id: 912, label: 'DELETE_RESOURCES' },
    { id: 920, label: 'CREATE_BATCH' },
    { id: 921, label: 'VIEW_BATCH' },
    { id: 922, label: 'MANAGE_PRODUCTION' },
    
    // Sales codes [1000 - 1099]
    { id: 1001, label: 'CREATE_PURCHASE' },
    { id: 1002, label: 'VIEW_TRANSACTIONS' },
    { id: 1003, label: 'VIEW_ALL_TRANSACTIONS' },
    { id: 1004, label: 'MANAGE_SALES_RETURNS' },
    { id: 1005, label: 'APPLY_STORE_CREDIT' },
    
    // Discount codes [1100 - 1199]
    { id: 1100, label: 'VIEW_DISCOUNT' },
    { id: 1101, label: 'CREATE_DISCOUNT' },
    { id: 1102, label: 'UPDATE_DISCOUNT' },
    { id: 1103, label: 'DELETE_DISCOUNT' },
    
    // Invoices [1200 - 1299]
    { id: 1200, label: 'CREATE_CUSTOM_INVOICES' },
    { id: 1201, label: 'VIEW_SEND_INVOICES' },
    { id: 1202, label: 'VIEW_RECEIVED_INVOICES' },
    { id: 1203, label: 'VIEW_SUMMARY_INVOICES' },
    
    // B2B [1300 - 1399]
    { id: 1300, label: 'VIEW_B2B_CLIENT' },
    { id: 1301, label: 'CREATE_B2B_CLIENT' },
    { id: 1302, label: 'UPDATE_B2B_CLIENT' },
    { id: 1303, label: 'DELETE_B2B_CLIENT' },
    { id: 1304, label: 'VIEW_B2B_PROFORMA' },
    { id: 1305, label: 'VIEW_B2B_ORDERS' },
    { id: 1306, label: 'CREATE_B2B_ORDERS' },
    { id: 1307, label: 'UPDATE_B2B_ORDERS' },
    { id: 1308, label: 'DELETE_B2B_ORDERS' },
    { id: 1309, label: 'VIEW_B2B_PAYMENTS' },
    { id: 1310, label: 'CREATE_B2B_PAYMENTS' },
    { id: 1311, label: 'UPDATE_B2B_PAYMENTS' },
    { id: 1312, label: 'CREATE_B2B_PROFORMA' },
    { id: 1313, label: 'UPDATE_B2B_PROFORMA' },
    { id: 1314, label: 'DELETE_B2B_PROFORMA' },
    { id: 1315, label: 'ACCEPT_B2B_PROFORMA' },
    { id: 1316, label: 'REJECT_B2B_PROFORMA' },
    { id: 1317, label: 'SEND_B2B_PROFORMA_EMAIL' },
    { id: 1318, label: 'VIEW_BILLING_STATEMENTS' },
    
    // Marketing codes [1400 - 1499]
    { id: 1400, label: 'MANAGE_MARKETING' },
    
    // Sites codes [1500 - 1599]
    { id: 1500, label: 'MANAGE_SITES' },
    { id: 1501, label: 'VIEW_SITES_ORDERS' },
    { id: 1502, label: 'VIEW_SITE_PRODUCTS' },
    { id: 1600, label: 'BULK_IMPORT_DATA' },
    { id: 1700, label: 'MANAGE_FIXED_EXPENSES' },
    { id: 1800, label: 'VIEW_TABLES' },
    { id: 1801, label: 'MANAGE_TABLE_LAYOUT' },
    { id: 1802, label: 'OPERATE_TABLES' },
    { id: 1803, label: 'CHARGE_TABLES' },
    { id: 1804, label: 'VOID_TABLE_ITEMS' },
    { id: 1900, label: 'USE_AI_ASSISTANT' },
    { id: 1901, label: 'MANAGE_AI_ASSISTANT' },
];

export const getPermissionById = (id) => {
    return permissionOptions.find(permission => permission.id === id);
};

export const categoryOptions = {
    SUPPLIES: 1,
    PRODUCTS: 2,
    PREPARATIONS: 3,
    PRODUCT: 4,
    OTHER: 100
};

export const getCategoriesById = (id) => {
    return categoryOptions.find(category => category.id === id);
};

export const paymentStatusOptions = [
    { id: 1, label: 'payment_finished', color: '#409c28' },
    { id: 2, label: 'payment_pending', color: '#d89d2b' },
    { id: 3, label: 'partial_payment', color: '#1976d2' }
];

export const REPLENISHMENT_PAYMENT_STATUS = {
    PAID: 1,
    PENDING: 2,
    PARTIAL: 3,
};

export const getReferenceTypeName = (type) => {
    switch (type) {
      case referenceTypes.INSUMO:
        return "Insumo";
      case referenceTypes.PREPARADO:
        return "Preparado";
      case referenceTypes.PRODUCTS:
        return "Producto";
      default:
        return "Desconocido";
    }
};

export const referenceTypes = {
    INSUMO: 1,
    PREPARADO: 2,
    CATEGORIES: 3,
    PRODUCTS: 4,
};

export const getReferenceById = (id) => {
    return referenceTypes.find(reference => reference.id === id);
};

export const schedule = {
    STANDARD: 1,
    EXTRA: 2,
    OOO: 3,
};

export const scheduleType = [
    { id: schedule.STANDARD, label: 'Estándar' },
    { id: schedule.EXTRA, label: 'Extra' },
    { id: schedule.OOO, label: 'OOO' }    
];


export const cashType = [
    { id: 1, label: 'Apertura' },
    { id: 2, label: 'Cierre' }
];

export const getCashTypeById = (id) => {
    return cashType.find(unit => unit.id === id) || { label: 'Unknown', id: 'Unknown' };
};

export const SALE_ORIGIN = {
  LOCAL: 1,
  WEB: 2,
  PEDIDOSYA: 3,
};

export const saleOrigin = [
  { id: SALE_ORIGIN.LOCAL, label: 'Local' },
  { id: SALE_ORIGIN.WEB, label: 'Web' },
  { id: SALE_ORIGIN.PEDIDOSYA, label: 'Pedidos YA' },
];

export const paymentType = [
  { id: 1, label: 'Efectivo', origin: [SALE_ORIGIN.LOCAL, SALE_ORIGIN.WEB] },
  { id: 2, label: 'Crédito', origin: [SALE_ORIGIN.LOCAL] },
  { id: 3, label: 'Debito', origin: [SALE_ORIGIN.LOCAL] },
  { id: 4, label: 'Mercado Pago', origin: [SALE_ORIGIN.LOCAL, SALE_ORIGIN.WEB] },
  { id: 5, label: 'Pedidos YA', origin: [SALE_ORIGIN.PEDIDOSYA] },
  { id: 6, label: 'Transferencia', origin: [SALE_ORIGIN.LOCAL, SALE_ORIGIN.WEB] },
  // Venta pagada con más de un medio: la asigna el sistema, no se elige (sin origen no aparece en los selectores).
  { id: 7, label: 'Mixto', origin: [] },
];

export const getOriginsForPaymentType = (paymentId) => {
  return paymentType.find(p => p.id === paymentId)?.origin || [];
};

/**
 * Precio de un producto/ítem según el canal de venta (origen), con fallback al precio base
 * cuando el canal no tiene un precio propio cargado.
 */
export const resolveChannelPrice = (item, origin) => {
  if (!item) return undefined;
  const channelPrice = Number(origin) === SALE_ORIGIN.WEB
    ? item.priceWeb
    : Number(origin) === SALE_ORIGIN.PEDIDOSYA
      ? item.pricePedidosYa
      : item.priceLocal;
  return channelPrice ?? item.price;
};

export const getPaymentTypesForOrigin = (originId) => {
  return paymentType.filter(p => p.origin.includes(originId));
};

export const getOriginLabel = (value) => {
    const option = saleOrigin.find((opt) => opt.id === value);
    return option?.label || '—';
};      

export const getPaymentLabel = (value) => {
    const option = paymentType.find((opt) => opt.id === value);
    return option?.label || '—';
};      

export const discountType = {
    PERCENTAGE: 1,
    BUY_X_PAY_Y: 2
};

export const getDiscountTypeLabel = (value) => {
    switch (value) {
        case 2:
            return 'Lleva X paga Y';
        case 1:
        default:
            return 'Porcentaje';
    }
};

export const paymentStatus = {
    PENDING: 1,
    PAID: 2,
    FAILED: 3,
    CANCELLED: 4,
};

export const getPaymentStatusLabel = (value) => {
    switch (value) {
      case 2: // Paid
        return 'Pago';
      case 3: // Failed
        return 'Error al procesar';
      case 4: // Cancelled
        return 'Cancelado';
      case 1: // Pending
      default:
        return 'Pendiente';
    }
};

export const getPaymentStatusColor = (value) => {
    switch (value) {
      case 2: // Paid
        return 'green';
      case 3: // Failed
      case 4: // Cancelled
        return 'red';
      case 1: // Pending
      default:
        return 'orange';
    }
};

export const invoiceStatus = [
    { id: 1, label: 'Pending' },
    { id: 2, label: 'Partially processed' },
    { id: 3, label: 'Processed' },
    { id: 4, label: 'Canceled' }
];

export const getInvoiceStatus = (value) => {
    const option = invoiceStatus.find((opt) => opt.id === value);
    return option?.label || '—';
};

export const getInvoiceStatusColor = (value) => {
    switch (value) {
      case 3: // Processed
        return 'green';
      case 4: // Canceled
        return 'red';
      case 1: // Pending
      case 2: // Partially processed
      default:
        return 'orange';
    }
};

export const movementTypes = [
  { value: 1, labelKey: "supply_purchase" },
  { value: 2, labelKey: "deposit" },
];

// ===== ENUMS PARA B2B ORDERS =====

export const ORDER_STATUS = {
  PENDING: 'PENDING',
  FINALIZED: 'FINALIZED',
  CANCELLED: 'CANCELLED'
};

export const PAYMENT_STATUS = {
  PAID: 'PAID',
  UNPAID: 'UNPAID',
  PARTIAL: 'PARTIAL',
  OVERDUE: 'OVERDUE'
};

export const PAYMENT_METHOD = {
  CASH: 'CASH',
  TRANSFER: 'TRANSFER',
  CHECK: 'CHECK',
  CARD: 'CARD'
};

export const DISCOUNT_TYPE = {
  PERCENTAGE: 'PERCENTAGE',
  AMOUNT: 'AMOUNT'
};

// Funciones helper para obtener opciones de los enums de B2B
export const getOrderStatusOptions = () => [
  { value: ORDER_STATUS.PENDING, label: 'Pendiente' },
  { value: ORDER_STATUS.FINALIZED, label: 'Entregado' },
  { value: ORDER_STATUS.CANCELLED, label: 'Cancelado' }
];

export const getPaymentStatusOptions = () => [
  { value: PAYMENT_STATUS.PAID, label: 'Pagado' },
  { value: PAYMENT_STATUS.UNPAID, label: 'Sin pagar' },
  { value: PAYMENT_STATUS.PARTIAL, label: 'Pago parcial' },
  { value: PAYMENT_STATUS.OVERDUE, label: 'Vencido' }
];

export const getPaymentMethodOptions = () => [
  { value: PAYMENT_METHOD.CASH, label: 'Efectivo' },
  { value: PAYMENT_METHOD.TRANSFER, label: 'Transferencia' },
  { value: PAYMENT_METHOD.CHECK, label: 'Cheque' },
  { value: PAYMENT_METHOD.CARD, label: 'Tarjeta de crédito' }
];

export const getDiscountTypeOptions = () => [
  { value: DISCOUNT_TYPE.PERCENTAGE, label: 'Porcentaje' },
  { value: DISCOUNT_TYPE.AMOUNT, label: 'Monto' }
];

// Funciones helper para obtener colores de los estados de B2B
export const getOrderStatusColor = (status) => {
  switch (status) {
    case ORDER_STATUS.PENDING: return 'warning';
    case ORDER_STATUS.FINALIZED: return 'success';
    case ORDER_STATUS.CANCELLED: return 'error';
    default: return 'default';
  }
};

export const getB2BPaymentStatusColor = (status) => {
  switch (status) {
    case PAYMENT_STATUS.PAID: return 'success';
    case PAYMENT_STATUS.UNPAID: return 'error';
    case PAYMENT_STATUS.PARTIAL: return 'warning';
    case PAYMENT_STATUS.OVERDUE: return 'error';
    default: return 'default';
  }
};

// Funciones helper para obtener texto traducido de los estados de B2B
export const getOrderStatusText = (status, t) => {
  switch (status) {
    case ORDER_STATUS.PENDING: return t('pending');
    case ORDER_STATUS.FINALIZED: return 'Entregado';
    case ORDER_STATUS.CANCELLED: return t('cancel');
    default: return status;
  }
};

export const getPaymentStatusText = (status, t) => {
  switch (status) {
    case PAYMENT_STATUS.PAID: return t('paid');
    case PAYMENT_STATUS.UNPAID: return t('unpaid');
    case PAYMENT_STATUS.PARTIAL: return t('partial_payment');
    case PAYMENT_STATUS.OVERDUE: return t('overdue');
    default: return status;
  }
};

// Validaciones para enums de B2B
export const isValidOrderStatus = (status) => {
  return Object.values(ORDER_STATUS).includes(status);
};

export const isValidPaymentStatus = (status) => {
  return Object.values(PAYMENT_STATUS).includes(status);
};

export const isValidPaymentMethod = (method) => {
  return Object.values(PAYMENT_METHOD).includes(method);
};

export const isValidDiscountType = (type) => {
  return Object.values(DISCOUNT_TYPE).includes(type);
};

// ===== ENUMS PARA EMAIL TEMPLATE CATEGORIES =====

export const EMAIL_TEMPLATE_CATEGORY = {
  PROMOTION: 'PROMOTION',
  MARKETING: 'MARKETING',
  WELCOME: 'WELCOME',
  NEWS: 'NEWS',
  REACTIVATION: 'REACTIVATION',
  NOTIFICATION: 'NOTIFICATION',
  REMINDER: 'REMINDER',
  NEWSLETTER: 'NEWSLETTER',
  TRANSACTIONAL: 'TRANSACTIONAL'
};

// Función helper para obtener opciones de categorías de plantillas
export const getEmailTemplateCategoryOptions = () => [
  { value: EMAIL_TEMPLATE_CATEGORY.PROMOTION, label: 'Promoción' },
  { value: EMAIL_TEMPLATE_CATEGORY.MARKETING, label: 'Marketing' },
  { value: EMAIL_TEMPLATE_CATEGORY.WELCOME, label: 'Bienvenida' },
  { value: EMAIL_TEMPLATE_CATEGORY.NEWS, label: 'Novedad' },
  { value: EMAIL_TEMPLATE_CATEGORY.REACTIVATION, label: 'Reactivación' },
  { value: EMAIL_TEMPLATE_CATEGORY.NOTIFICATION, label: 'Notificación' },
  { value: EMAIL_TEMPLATE_CATEGORY.REMINDER, label: 'Recordatorio' },
  { value: EMAIL_TEMPLATE_CATEGORY.NEWSLETTER, label: 'Newsletter' },
  { value: EMAIL_TEMPLATE_CATEGORY.TRANSACTIONAL, label: 'Transaccional' }
];

// Función helper para obtener el label de una categoría
export const getEmailTemplateCategoryLabel = (category) => {
  const option = getEmailTemplateCategoryOptions().find(opt => opt.value === category);
  return option?.label || category || '—';
};

// Validación para categorías de plantillas
export const isValidEmailTemplateCategory = (category) => {
  return Object.values(EMAIL_TEMPLATE_CATEGORY).includes(category);
};

// ===== ENUMS PARA COMPANY TYPE =====

export const COMPANY_TYPE = {
  FOOD_SERVICE: 2,
  RETAIL: 3
};

export const companyTypeOptions = [
  { id: COMPANY_TYPE.FOOD_SERVICE, label: 'Food Service' },
  { id: COMPANY_TYPE.RETAIL, label: 'Retail' }
];

export const getCompanyTypeById = (id) => {
  return companyTypeOptions.find(type => type.id === id) || { label: 'Unknown', id: null };
};

export const getCompanyTypeLabel = (id) => {
  const option = getCompanyTypeById(id);
  return option?.label || '—';
};
